module.exports = __webpack_public_path__ + "img/culture4.99886f09.jpg";